import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-100 mt-auto">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-sm font-light tracking-wide text-gray-900">
              STUDIO
            </Link>
            <p className="text-xs text-gray-400 mt-3 leading-relaxed">
              Minimalist clothing for the modern wardrobe.
            </p>
          </div>

          {/* Shop */}
          <div>
            <h3 className="text-[10px] font-light tracking-wide uppercase text-gray-400 mb-3">
              Shop
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-xs text-gray-500 hover:text-gray-900 transition">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/products?category=men" className="text-xs text-gray-500 hover:text-gray-900 transition">
                  Men
                </Link>
              </li>
              <li>
                <Link to="/products?category=women" className="text-xs text-gray-500 hover:text-gray-900 transition">
                  Women
                </Link>
              </li>
              <li>
                <Link to="/products?category=kids" className="text-xs text-gray-500 hover:text-gray-900 transition">
                  Kids
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-[10px] font-light tracking-wide uppercase text-gray-400 mb-3">
              Support
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/faq" className="text-xs text-gray-500 hover:text-gray-900 transition">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-xs text-gray-500 hover:text-gray-900 transition">
                  Shipping
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-xs text-gray-500 hover:text-gray-900 transition">
                  Returns
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-xs text-gray-500 hover:text-gray-900 transition">
                  Privacy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-[10px] font-light tracking-wide uppercase text-gray-400 mb-3">
              Contact
            </h3>
            <ul className="space-y-2">
              <li className="text-xs text-gray-500">
                info@studio.com
              </li>
              <li className="text-xs text-gray-500">
                +855 12 345 678
              </li>
              <li className="text-xs text-gray-500">
                Phnom Penh, Cambodia
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-100 mt-10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[10px] text-gray-400 tracking-wide">
              © 2024 STUDIO. All rights reserved.
            </p>
            <div className="flex gap-6">
              <span className="text-[10px] text-gray-400 tracking-wide">Terms</span>
              <span className="text-[10px] text-gray-400 tracking-wide">Privacy</span>
              <span className="text-[10px] text-gray-400 tracking-wide">Cookies</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;